import { ActionTree } from 'vuex/types/index'
import { RootState } from '~/store/store.types'
import { AttachmentType } from './attachments.types'

const actions: ActionTree<{}, RootState> = {
  async uploadImage ({ rootGetters }, { file, attachmentType, applicationId }) {
    const getter = attachmentType === AttachmentType.Headshot ? 'headshotForApplication' : 'identificationForApplication'

    const existingId = rootGetters[`applications/applications/${getter}`](applicationId).id

    const formData = new FormData()

    formData.append('file', file)
    formData.append('attachment_type', attachmentType)

    // This route is apparently deliberately not JSONAPI compliant as it involves an image upload 🤷‍♂️
    if (existingId) {
      await this.$axios.patch(
        `applications/applications/${applicationId}/attachments/${existingId}`,
        formData,
        { timeout: 120000 }
      )
    } else {
      await this.$axios.post(
        `applications/applications/${applicationId}/attachments`,
        formData,
        { timeout: 120000 }
      )
    }
  }
}

export default actions
